import { IconProps } from '../types'

const Upskill = (props: IconProps) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M-0.000244141 12C-0.000244141 5.37258 5.37234 0 11.9998 0H35.9998C42.6272 0 47.9998 5.37258 47.9998 12V36C47.9998 42.6274 42.6272 48 35.9998 48H11.9998C5.37234 48 -0.000244141 42.6274 -0.000244141 36V12Z"
      fill="currentColor"
    />
    <g clipPath="url(#clip0_656_16229)">
      <path
        d="M10.8602 20.5385L22.5871 15.2204L34.8814 20.072L31.1931 22.4978L30.7203 29.402L29.3858 30.7185C28.1089 31.9779 26.4266 32.7583 24.6289 32.925L21.2243 33.2394C20.3149 33.3236 19.3977 33.216 18.5336 32.9239C17.6694 32.6318 16.8781 32.1618 16.212 31.5451L13.6974 29.2154L13.5082 22.9643L10.8602 20.5385Z"
        fill="white"
      />
      <path
        d="M22.4245 34.5251C17.0102 34.5251 13.9698 31.8371 13.5083 31.268C13.13 30.8015 13.0354 29.8685 13.0354 29.5886C13.0354 28.4531 12.8463 27.3205 12.8463 26.3231C12.8463 25.8566 13.13 25.2511 13.5697 25.0738C14.6431 24.6437 14.9268 25.6336 14.9268 26.3231C14.9268 27.4585 15.2105 29.9618 15.2105 29.9618C15.2105 29.9618 15.5207 30.3723 15.778 30.5216C16.9866 31.2251 19.2383 32.3409 22.6354 32.284C26.823 32.2159 28.4846 30.1801 29.3774 29.0866L29.4719 28.9663V22.7833C29.4688 22.5226 29.5688 22.2711 29.7507 22.082C29.9326 21.893 30.182 21.7814 30.446 21.771C31.0031 21.7607 31.7558 22.0443 31.7558 22.5911L31.6613 28.9355C31.6613 29.402 31.1884 30.2417 30.9198 30.5953C30.0214 31.7774 27.7819 34.4402 22.6628 34.5232C22.5871 34.5251 22.5049 34.5251 22.4245 34.5251Z"
        fill="#1E2532"
      />
      <path
        d="M22.2645 26.9855C21.8549 26.9502 21.4532 26.8526 21.0738 26.6963C18.5327 25.474 11.3746 22.0695 9.96736 21.3996C9.75248 21.3004 9.55963 21.1603 9.39993 20.9872C9.11622 20.6728 8.80318 20.1186 9.15782 19.6987C9.41033 19.3993 11.1627 18.554 11.5221 18.3925C14.643 16.993 20.601 14.4739 20.601 14.4739C22.8707 13.5409 23.6273 14.194 24.9513 14.6605C24.9513 14.6605 29.3678 16.4939 32.4224 17.8327C33.2736 18.2059 35.7514 19.3069 36.0162 19.6054C36.6782 20.3518 35.827 21.0983 35.0704 21.3782C35.0704 21.3782 26.9136 25.2342 23.7218 26.603C23.5942 26.658 22.7761 26.9762 22.2645 26.9855ZM12.2049 20.3929L22.273 24.9329L33.1232 20.2399L22.587 16.06L12.2049 20.3929Z"
        fill="#1E2532"
      />
      <path
        d="M38.6813 31.5013L36.5837 28.8888L36.6783 23.9934C36.6783 23.1537 36.2811 22.4073 35.7326 22.4073C35.184 22.4073 34.6923 23.1257 34.6923 23.6668L34.5977 28.8254L32.6552 31.2512C32.3138 31.6739 31.8806 32.7981 32.3403 33.0948C33.2737 33.6975 34.0123 32.7151 34.208 32.4734L35.5169 30.8388L36.8674 32.201C37.3403 32.8541 37.8812 33.274 38.2151 33.274C38.3985 33.274 38.5783 33.2236 38.7343 33.1284C39.2014 32.8448 38.9688 31.9612 38.6813 31.5013Z"
        fill="#1E2532"
      />
      <path
        d="M36.4891 32.5742C36.4891 34.0166 36.5837 35 35.4488 35C34.5031 35 34.5031 33.7367 34.5031 32.2943C34.5031 30.8519 34.9268 29.6819 35.4488 29.6819C35.9709 29.6819 36.4891 31.1318 36.4891 32.5742Z"
        fill="#1E2532"
      />
    </g>
    <defs>
      <clipPath id="clip0_656_16229">
        <rect width="30" height="21" fill="white" transform="translate(9 14)" />
      </clipPath>
    </defs>
  </svg>
)

export default Upskill
